import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { action: String, fallbackUrl: String }

  connect() {
    this._onKeydown = this._onKeydown.bind(this);
    document.addEventListener("keydown", this._onKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown);
  }

  _onKeydown(e) {
    if (e.key === "Escape" && this.actionValue === "back") {
      const isFirstHistoryEntry =
        !window.history.state?.turbo ||
        window.history.state.turbo.restorationIndex === 0;

      if (!isFirstHistoryEntry) {
        window.history.back();
      } else if (this.hasFallbackUrlValue) {
        window.location.href = this.fallbackUrlValue;
      }
    }
  }
}
